import React from "react";
import deleteIcon from "../assets/delete.png";
import { Link } from "react-router-dom";

const NoAccess = () => {
  const notFoundStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#f8f8f8",
  };

  const contentStyle = {
    textAlign: "center",
  };

  const headingStyle = {
    fontSize: "6em",
    margin: 0,
    color: "#ff3d2e",
  };

  const paragraphStyle = {
    fontSize: "1.5em",
    color: "#555",
  };

  const linkStyle = {
    marginTop: "20px",
    display: "inline-block",
    padding: "10px 20px",
    fontSize: "1.2em",
    color: "#fff",
    backgroundColor: "#3498db",
    textDecoration: "none",
    borderRadius: "5px",
    transition: "background-color 0.3s ease",
  };

  return (
    <div style={notFoundStyle}>
      <div style={contentStyle}>
        <h1 style={headingStyle}>
          <span>
            <img src={deleteIcon} alt="no_access" style={{ height: "67px", margin:"10px" ,marginBottom:"28px"}} />
          </span>
          Access Deny
        </h1>
        <p style={paragraphStyle}>
          You don't have permission to access this page.
        </p>
        <Link to="/" style={linkStyle}>
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default NoAccess;
